import * as React from "react";

import { SmsApi, SmsSearch, ETextSearchType } from "../../../../../api";
import { useAbortableApiServiceFactory, useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { SearchTablePage } from "../../../../../components";
import { useGlobalData } from "../../../../../contexts";

interface IApprenantSMSProps {
  apprenantId: number;
}

export const ApprenantSMS: React.FunctionComponent<IApprenantSMSProps> = ({ apprenantId }) => {
  const { t } = useTl();
  const api = useApiService(SmsApi);
  const { currentAnneeScolaire } = useGlobalData();

  const columns = React.useMemo(
    () => [
      {
        header: () => t(ETLCodes.Message),
        fieldName: "message"
      },
      {
        header: () => t(ETLCodes.DateEnvoi),
        fieldName: "dateEnvoi"
      },
      {
        header: () => t(ETLCodes.Statut),
        fieldName: "status"
      }
    ],
    [t]
  );

  const getCriteriasFn = React.useCallback(() => api.smsGetSearchCriterias({ includeListsValues: true }), [api]);

  const apiFactory = useAbortableApiServiceFactory(SmsApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFunction = React.useCallback(
    (sObj?: SmsSearch) => {
      sObj.idApprenant = apprenantId;
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.smsBaseSearch({ SmsSearch: sObj });
    },
    [apiFactory, apprenantId]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    apprenantId > 0 && (
      <SearchTablePage
        columns={columns}
        getCriteriasFunction={getCriteriasFn}
        searchFunction={searchFunction}
        onAbort={onAbort}
        sortKeys={{ dateEnvoi: "DESC" }}
        title={ETLCodes.SMS}
        withCard={false}
        defaultCriterias={[
          {
            criteria: "AnneeScolaire",
            searchMode: ETextSearchType.Equals,
            value: currentAnneeScolaire?.idanneeScolaire
          }
        ]}
      />
    )
  );
};
